import { useTranslator } from '@picsart/rc/services/localization';
import { Text, Button } from 'theme-ui';
import { currencySymbol } from '../OneTimePayAccordion';
import Icon from 'shared/Icon';

type TitleProps = {
  handleClick: () => void;
  isOpen: boolean;
  totalCount: number;
  totalAmount: number;
};
export const Title = ({ handleClick, isOpen = false, totalCount, totalAmount }: TitleProps) => {
  const translate = useTranslator();
  return (
    <Button
      onClick={handleClick}
      style={{
        lineHeight: '16px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        cursor: 'pointer',
        background: 'unset',
        padding: 'unset',
        width: '100%',
        paddingBottom: 12
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Text variant="bulletSmall" sx={{ fontSize: 12, fontWeight: 'bold', color: 'grey7' }}>
          {`${totalCount}x `}
          {translate(totalCount === 1 ? 'Premium Item' : 'Premium Items')}
        </Text>
        <Icon
          sx={{ display: 'block', width: '24px', color: 'grey7' }}
          name={isOpen ? 'arrow-small-up-gen' : 'arrow-small-down-gen'}
        />
      </div>
      <Text variant="bulletSmall" sx={{ fontSize: 14, fontWeight: 'bold', color: 'grey7' }}>
        {currencySymbol}
        {totalAmount}
      </Text>
    </Button>
  );
};
